<header class="navbar navbar-expand-lg navbar-light bg-dark bd-navbar">
  <nav
    class="container-fluid bd-gutter flex-wrap flex-lg-nowrap"
    aria-label="Main navigation"
  >
    <button
      class="navbar-toggler d-lg-none p-2 me-15"
      type="button"
      data-bs-toggle="offcanvas"
      data-bs-target="#bdNavbar"
      aria-controls="bdNavbar"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <!-- <svg class="bi" width="24" height="24" aria-hidden="true">
        <use xlink:href="#three-dots"></use>
      </svg> -->
      <i class="material-icons-round"> menu </i>
    </button>

    <a
      routerLink="/"
      class="no-borders navbar-brand fw-bold fs-4 p-0 me-4 mt-m-10 text-decoration-none"
    >
      <img
        class="nav-logo"
        src="../../../../assets/img/illusbook-logo-white.svg"
        alt="illusbook"
      />
    </a>

    <!-- mobile view start -->

    <div class="sm-dropdown-avatar" *ngIf="user">
      <div class="dropdown d-lg-none">
        <a
          class="btn text-decoration-none dropdown-toggle"
          id="bd-versions"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          data-bs-display="static"
        >
          <img
            class="nav-avatar rounded-circle img-fluid"
            [src]="user?.photoURL || 'assets/img/avatar.png'"
            (error)="onImageError($event)"
            loading="lazy"
            alt="avatar"
          />
        </a>

        <ul
          class="shadow mb-5 bg-body rounded border-0 dropdown-menu dropdown-menu-end"
          aria-labelledby="bd-versions"
        >
          <li class="px-5 dropdown-item rounded-3 py-3" *ngIf="user">
            <div class="justify-content-md-center">
              <div class="text-center">
                <div class="py-2">
                  <img
                    class="nav-avatar-lg rounded-circle img-fluid"
                    [src]="user?.photoURL || 'assets/img/avatar.png'"
                    (error)="onImageError($event)"
                    loading="lazy"
                    alt="avatar"
                  />
                </div>
              </div>

              <div class="text-center">
                <span class="fw-bold">{{ user?.name ? user.name : "" }}</span>
                <p class="mb-2">{{ user?.email ? user.email : "" }}</p>
                <a
                  routerLink="/profile"
                  class="mt-2 btn btn-sm btn-outline-black rounded-3"
                  >Edit Profile</a
                >
              </div>
            </div>
          </li>

          <li *ngIf="user">
            <hr class="dropdown-divider" />
          </li>

          <li *ngIf="user">
            <a
              routerLink="/downloads"
              data-bs-dismiss="offcanvas"
              data-bs-target="#bdNavbar"
              class="fs-sm dropdown-item rounded-3 mb-1"
            >
              <img
                class="main-icon"
                src="../../../../assets/img/download_done.svg"
                alt="icon"
              />
              &nbsp; Downloads
            </a>
          </li>

          <li *ngIf="user">
            <a
              routerLink="/favorites"
              data-bs-dismiss="offcanvas"
              data-bs-target="#bdNavbar"
              class="fs-sm dropdown-item rounded-3 mb-1"
            >
              <img
                class="main-icon"
                src="../../../../assets/img/favourite.svg"
                alt="icon"
              />
              &nbsp; Favorites
            </a>
          </li>

          <li *ngIf="user">
            <a
              routerLink="/subscription"
              data-bs-dismiss="offcanvas"
              data-bs-target="#bdNavbar"
              class="fs-sm dropdown-item rounded-3"
            >
              <img
                class="main-icon"
                src="../../../../assets/img/subscription.svg"
                alt="icon"
              />
              &nbsp; Subscription
              <span
                class="badge rounded cursor"
                [ngClass]="
                  user?.isSubscribed ? 'text-bg-dark' : 'text-bg-light border'
                "
                >{{ user?.isSubscribed ? "Pro" : "Free" }}</span
              >
            </a>
          </li>

          <li *ngIf="user">
            <hr class="dropdown-divider" />
          </li>

          <li *ngIf="user" (click)="logout()">
            <a
              class="cursor fs-sm dropdown-item"
              data-bs-dismiss="offcanvas"
              data-bs-target="#bdNavbar"
            >
              <img
                class="main-icon"
                src="../../../../assets/img/logout.svg"
                alt="icon"
              />
              &nbsp; Logout
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- mobile view end -->

    <div
      class="offcanvas-lg offcanvas-start flex-grow-1"
      id="bdNavbar"
      aria-labelledby="bdNavbarOffcanvasLabel"
      data-bs-scroll="true"
    >
      <div class="offcanvas-header px-4 pb-0">
        <img data-bs-dismiss="offcanvas" data-bs-target="#bdNavbar"
          class="nav-logo"
          src="../../../../assets/img/illusbook-logo-white.svg"
          alt="illusbook"
        />
        <button
          type="button"
          class="btn-close btn-close-white"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          data-bs-target="#bdNavbar"
        ></button>
      </div>

      <div class="offcanvas-body p-4 pt-0 p-lg-0">
        <hr class="d-lg-none text-white-50" />

        <ul
          class="navbar-nav menu-list-height flex-wrap bd-navbar-nav pt-2 py-md-0"
        >
          <!-- <li
            class="nav-item dropdown hybrid-dropdown me-3"
            [class.open]="isDropdownOpen"
            (mouseenter)="onHover(true)"
            (mouseleave)="onHover(false)"
          >
            <a
              (click)="toggleDropdown($event)"
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDarkDropdownMenuLink"
              role="button"
              aria-expanded="false"
            >
              Categories
            </a>
            <ul
              class="dropdown-menu dropdown-menu-dark"
              aria-labelledby="navbarDropdown"
            >
              <li *ngFor="let cate of cateData">
                <a
                  data-bs-dismiss="offcanvas"
                  data-bs-target="#bdNavbar"
                  class="dropdown-item"
                  [routerLink]="['/search/']"
                  [queryParams]="{
                    cate: cate.categoryName,
                    searchKey: searchkey
                  }"
                  >{{ cate.categoryName }}</a
                >
              </li>
              <li *ngIf="cateData.length == 0">No data found</li>
            </ul>
          </li> -->

          <li class="nav-item">
            <a
              routerLink="/collections"
              data-bs-dismiss="offcanvas"
              data-bs-target="#bdNavbar"
              class="nav-link py-2 px-0 px-lg-2 me-2"
              >Collections</a
            >
          </li>

          <li class="nav-item">
            <a
              routerLink="/ai-images"
              data-bs-dismiss="offcanvas"
              data-bs-target="#bdNavbar"
              class="nav-link py-2 px-0 px-lg-2 me-2"
              >AI Images <span class="badge text-brand text-bg-dark">New</span>
              
              </a
            >
          </li>

          <li class="nav-item" *ngIf="!user || !user.isSubscribed">
            <a
              routerLink="/pricing"
              data-bs-dismiss="offcanvas"
              data-bs-target="#bdNavbar"
              class="nav-link py-2 px-0 px-lg-2 me-2"
              >Pricing</a
            >
          </li>
        </ul>

        <ul class="navbar-nav menu-list-height flex-wrap ms-md-auto">
          <!-- *ngIf="user && user.isSubscribed" -->
          <li
            class="nav-item col-lg-auto"
          >
            <a
              data-bs-toggle="modal"
              data-bs-dismiss="offcanvas"
              data-bs-target="#suggestModal"
              class="cursor nav-link py-2 px-0 px-lg-2 me-2"
            >
              Custom Request</a
            >
          </li>

          <li class="nav-item mt-1 col-lg-auto" *ngIf="!user">
            <button
              (click)="navigateToLogin()"
              data-bs-dismiss="offcanvas"
              data-bs-target="#bdNavbar"
              class="d-lg-inline-block rounded-3 my-2 my-md-0 btn btn-sm btn-outline-light"
              >Log in</button>
          </li>

          <div class="dropdown hide-sm" *ngIf="user">
            <a
              class="btn text-decoration-none dropdown-toggle"
              id="bd-versions"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              data-bs-display="static"
            >
              <img
                class="nav-avatar rounded-circle img-fluid"
                [src]="user?.photoURL || 'assets/img/avatar.png'"
                (error)="onImageError($event)"
                loading="lazy"
                alt="avatar"
              />
            </a>

            <ul
              class="shadow mb-5 bg-body rounded border-0 dropdown-menu dropdown-menu-end"
              aria-labelledby="bd-versions"
            >
              <li class="px-5 dropdown-item rounded-3 py-3">
                <div class="justify-content-md-center">
                  <div class="text-center">
                    <div class="py-2">
                      <img
                        class="nav-avatar-lg rounded-circle img-fluid"
                        [src]="user?.photoURL || 'assets/img/avatar.png'"
                        (error)="onImageError($event)"
                        loading="lazy"
                        alt="avatar"
                      />
                    </div>
                  </div>
                  <div class="text-center">
                    <span class="fw-bold">{{ user?.name }}</span>
                    <p class="mb-2">{{ user?.email }}</p>
                    <a
                      routerLink="/profile"
                      class="mt-2 rounded-2 font-semi btn btn-sm btn-outline-black"
                      >Edit Profile</a
                    >
                  </div>
                </div>
              </li>

              <li>
                <hr class="dropdown-divider" />
              </li>

              <li>
                <a
                  routerLink="/downloads"
                  class="fs-sm dropdown-item rounded-3 mb-1"
                >
                  <img
                    class="main-icon"
                    src="../../../../assets/img/download_done.svg"
                    alt="icon"
                  />
                  &nbsp; Downloads
                </a>
              </li>

              <li>
                <a
                  routerLink="/favorites"
                  class="fs-sm dropdown-item rounded-3 mb-1"
                >
                  <img
                    class="main-icon"
                    src="../../../../assets/img/favourite.svg"
                    alt="icon"
                  />
                  &nbsp; Favorites
                </a>
              </li>

              <li *ngIf="user">
                <a
                  routerLink="/subscription"
                  class="fs-sm dropdown-item rounded-3"
                >
                  <img
                    class="main-icon"
                    src="../../../../assets/img/subscription.svg"
                    alt="icon"
                  />
                  &nbsp; Subscription
                  <span
                    class="badge rounded cursor"
                    [ngClass]="
                      user?.isSubscribed
                        ? 'text-bg-dark'
                        : 'text-bg-light border'
                    "
                    >{{ user?.isSubscribed ? "Pro" : "Free" }}</span
                  >
                </a>
              </li>

              <li>
                <hr class="dropdown-divider" />
              </li>

              <li>
                <a
                  class="cursor fs-sm dropdown-item rounded-3"
                  (click)="logout()"
                >
                  <img
                    class="main-icon"
                    src="../../../../assets/img/logout.svg"
                    alt="icon"
                  />
                  &nbsp; Logout
                </a>
              </li>
            </ul>
          </div>
        </ul>
      </div>
    </div>
  </nav>
</header>

<div
  class="modal fade"
  id="suggestModal"
  tabindex="-1"
  aria-labelledby="suggestModalLabel"
  aria-hidden="true"
  #suggestModal
>
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content rounded-4">
      <div class="alert alert-success" role="alert" *ngIf="message">
        {{ message }}
      </div>
      <div class="modal-header ps-4 pe-4">
        <h5 class="modal-title" id="suggestModalLabel">
          Request a Custom Illustration
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="pb-3 ps-4 pe-4 col-md-12 mx-auto">
            <p class="mb-4">
              Have something specific in mind? Submit your request and we’ll
              create it for you.
            </p>
            <form
              role="form"
              [formGroup]="suggestContent"
              #f="ngForm"
              *ngIf="suggestContent"
              (ngSubmit)="
                submitContent(suggestContent.value, suggestContent.valid)
              "
            >
              <div class="mb-3">
                <textarea
                  class="rounded-3 text-secondary boxz form-control"
                  placeholder="Describe your illustration needs in detail"
                  cols="30"
                  rows="5"
                  formControlName="suggestions"
                ></textarea>
              </div>

              <div>
                <button
                  type="submit"
                  class="mt-1 rounded-3 w-100 btn btn-ib-black"
                >
                  <span *ngIf="!loader">Submit</span>
                  <div
                    *ngIf="loader"
                    class="spinner-border spinner-border-sm"
                    role="status"
                  >
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<svg xmlns="http://www.w3.org/2000/svg" style="display: none">
  <symbol id="three-dots" viewBox="0 0 16 16">
    <path
      d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
    />
  </symbol>
</svg>
